import script from "./SoftDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftDialog.vue?vue&type=script&setup=true&lang=js"

import "./SoftDialog.vue?vue&type=style&index=0&id=27618c3a&lang=less"

const __exports__ = script;

export default __exports__